// extracted by mini-css-extract-plugin
export default {"divisions":"divisions_divisions__HrfWE","title":"divisions_title__d7MRF","cardsWrapper":"divisions_cardsWrapper__84XUL"};